module.exports = __webpack_public_path__ + "static/img/ask3-tit.8d87464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/ask3-tit.png
// module id = oSPO
// module chunks = 0